import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  OnDestroy,
  effect,
  ElementRef,
  inject,
} from '@angular/core';
import { RightBridgeApiService } from '../../services/right-bridge-api.service';
import { Context } from '../../models/admin-models';
import {
  ActivatedRoute,
  Router,
  Event as NavigationEvent,
  NavigationStart,
} from '@angular/router';
import { Location } from '@angular/common';
import { SessionStorageService } from '../../services/session-storage.service';
import { ModuleStatusService } from '../../services/module-status.service';
import { FormlyComponent } from '../../conditional-form/formly.component';
import { UnifiedFlowService } from '../unified.service';
import { MatDialog } from '@angular/material/dialog';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, filter, takeUntil } from 'rxjs/operators';
import { FormService } from '../../conditional-form/form-service.service';
import { WarnDialogComponent } from '../../warn-dialog/warn-dialog.component';
import { CopyCaseModalComponent } from '../copy-case-modal/copy-case-modal.component';
import { MatSnackBar } from '@angular/material/snack-bar';

import { PpResultsComponent } from '../pp-results/pp-results.component';
import { AwComparisonComponent } from '../aw-comparison/aw-comparison.component';
import { AnnuitiesResultComponent } from '../../annuity-wizard/annuities-result/annuities-result.component';
import { ProgramSelectionComponent } from '../../investment-wizard/program-selection/program-selection.component';
import { ModelSelectionComponent } from '../../investment-wizard/model-selection/model-selection.component';
import { FundAllocationsComponent } from '../../investment-wizard/fund-allocations/fund-allocations.component';
import { ValidateResultComponent } from '../../investment-wizard/validate-result/validate-result.component';
import { ResultComponent } from '../../life-wizard/results/results.component';
import { ScenariosComponent } from '../../life-wizard/scenarios/scenarios.component';
import { ValidateComponent } from '../../life-wizard/validate/validate.component';
import { ProductResultComponent } from '../../shared-components/product-result/product-result.component';
import { UnifiedSummaryPageComponent } from '../unified-summary-page/unified-summary-page.component';
import { MainNavComponent } from '../main-nav/main-nav.component';
import { LeftNavComponent } from '../left-nav/left-nav.component';
import { NgxLoadingModule } from 'ngx-loading';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MarkdownService } from 'ngx-markdown';

@Component({
  selector: 'app-unified-case',
  templateUrl: './unified-case.component.html',
  styleUrls: ['./unified-case.component.scss'],
  standalone: true,
  imports: [
    PpResultsComponent,
    AwComparisonComponent,
    AnnuitiesResultComponent,
    ProgramSelectionComponent,
    ModelSelectionComponent,
    FundAllocationsComponent,
    ValidateResultComponent,
    ResultComponent,
    ScenariosComponent,
    ValidateComponent,
    ProductResultComponent,
    UnifiedSummaryPageComponent,
    MainNavComponent,
    LeftNavComponent,
    FormlyComponent,
    NgxLoadingModule,
    MatTooltipModule,
    MatIconModule,
    MatButtonModule,
  ],
  providers: [MarkdownService],
})
export class UnifiedCaseComponent implements OnInit, AfterViewInit, OnDestroy {
  private rbs = inject(RightBridgeApiService);
  private route = inject(ActivatedRoute);
  unfFlowSvc = inject(UnifiedFlowService);
  private location = inject(Location);
  private ss = inject(SessionStorageService);
  modStatusSvc = inject(ModuleStatusService);
  private router = inject(Router);
  private dialog = inject(MatDialog);
  private snacky = inject(MatSnackBar);
  private frmSvc = inject(FormService);

  @ViewChild(FormlyComponent, { static: false })
  private questionnaire: FormlyComponent;
  @ViewChild('focusCatcher', { static: false })
  private focusCatcher: ElementRef;
  isNaN: (value: unknown) => boolean = Number.isNaN;

  tabContext: Context = { type: 'unified', unit: null, app: null };
  profileData;
  loading = false;
  save = 'og';
  steps = [];
  tabChange;
  state;
  currentApp = 'rb';
  profile;
  resultsPage = { app: null, visible: false };
  availableApps = [];
  currentStep: any = 0;
  formModel = {};
  dataLoaded = false;
  liValidate = false;
  iwValidate = false;
  availableAppStatus = {
    clientinfo: {
      available: false,
      required: false,
      ShowInSidebarNav: false,
    },
    aw: {
      available: false,
      required: false,
      ShowInSidebarNav: false,
    },
    pp: {
      available: false,
      required: false,
      ShowInSidebarNav: false,
    },
    iw: {
      available: false,
      required: false,
      ShowInSidebarNav: false,
    },
    li: {
      available: false,
      required: false,
      ShowInSidebarNav: false,
    },
  };
  rights = [];
  notesValid = true;
  navDisabled = false;
  newProfileObs;
  prodsSelectedPP = false;
  progSelectedIW = null;
  stepsObs;
  summaryClient = '';
  summaryCaseNumber = '';
  formValid = true;
  downloadingFactsheet = false;
  unsubscribe: Subject<any> = new Subject();
  formSubmitted = false;
  initialErrorsList = [];
  noSaveProfile = false;
  modules = [];
  formModified = false;
  prodSelectedLW: any;
  triggerTabChange: Subscription;
  triggerAppChange: Subscription;
  triggerCheckGetQuestionnaire = false;

  constructor() {
    const router = this.router;

    this.rights = this.ss.get('rights');
    this.noSaveProfile = this.rights?.includes('ReadOnly');
    router.events
      .pipe(
        takeUntil(this.unsubscribe),
        filter((event: NavigationEvent) => {
          return event instanceof NavigationStart;
        })
      )
      .subscribe((ev: NavigationEvent) => {
        if (ev instanceof NavigationStart) {
          const eventUrl = ev.url.split('/');
          const urlApp = eventUrl[2] ? eventUrl[2].toLowerCase() : '';
          const validApp =
            urlApp === 'aw' ||
            urlApp === 'pp' ||
            urlApp === 'rb' ||
            urlApp === 'li' ||
            urlApp === 'iw';

          if (
            this.currentApp === 'li' &&
            (this.currentStep === 'validate' ||
              this.currentStep === 'products' ||
              this.currentStep === 'compare' ||
              this.currentStep === 'results') &&
            eventUrl[eventUrl.length - 1] === '0' &&
            ev.navigationTrigger === 'popstate'
          ) {
            this.getQuestionnaire();
          } else if (validApp && urlApp !== this.currentApp) {
            this.currentApp = urlApp;
            this.getQuestionnaire();
          }
        }
      });

    effect(() => {
      if (
        this.frmSvc.formModified().modified &&
        this.modStatusSvc.appStatuses().complete.includes(this.currentApp)
      ) {
        this.formModified = true;
      } else {
        this.formModified = false;
      }
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.profile = params.id;

      this.currentApp = params.app ? params.app : 'rb';
      this.currentStep = params.step ? params.step : this.currentStep;
      this.ss.set('currentStep', this.currentStep);
      this.ss.set('currentApp', this.currentApp);
      if (this.triggerCheckGetQuestionnaire) {
        this.triggerCheckGetQuestionnaire = false;
        if (this.isNaN(+this.currentStep)) {
          this.getQuestionnaire();
        }
      }
    });

    this.triggerTabChange = this.unfFlowSvc.triggerTabChangeExternal.subscribe(
      change => {
        this.handleTabChange(change);
      }
    );

    this.triggerAppChange = this.unfFlowSvc.triggerAppChangeExternal.subscribe(
      ev => {
        this.handleAppChange(ev);
      }
    );

    this.setModuleStatus();

    this.availableApps = this.ss.get('availableApps');

    if (!this.availableApps || typeof this.availableApps === 'undefined') {
      this.availableApps = [];

      if (this.rights?.includes('PP')) {
        this.availableApps.push('pp');
        this.availableApps.push('clientinfo');
      }

      if (this.rights?.includes('AW')) {
        this.availableApps.push('aw');
      }

      if (this.rights?.includes('IW')) {
        this.availableApps.push('iw');
      }

      if (this.rights?.includes('LI')) {
        this.availableApps.push('li');
      }

      this.ss.set('availableApps', this.availableApps);
    }
    if (!this.isNaN(+this.currentStep)) {
      this.getQuestionnaire();
    }
    this.ss.set('currentStep', this.currentStep);
  }

  ngAfterViewInit() {
    if (!this.newProfileObs) {
      this.newProfileObs = this.unfFlowSvc.newProfileExternal;
      this.newProfileObs.subscribe(x => this.handleNewProfile(x));
    }

    if (!this.stepsObs) {
      this.stepsObs = this.unfFlowSvc.stepsListExternal;
      this.stepsObs.pipe(debounceTime(50)).subscribe(x => {
        this.steps = x;
      });

      if (!this.steps.length && this.currentStep === 'compare-results') {
        this.getQuestionnaire();
      }
    }

    if (!this.steps.length && this.currentStep === 'compare-results') {
      this.getQuestionnaire();
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
    this.triggerTabChange?.unsubscribe();
    this.triggerAppChange?.unsubscribe();
  }

  setModuleStatus() {
    this.availableAppStatus = {
      clientinfo: {
        available: this.currentApp === 'rb',
        required: false,
        ShowInSidebarNav: false,
      },
      aw: {
        available: this.currentApp === 'aw',
        required: false,
        ShowInSidebarNav: false,
      },
      pp: {
        available: this.currentApp === 'pp',
        required: false,
        ShowInSidebarNav: false,
      },
      iw: {
        available: this.currentApp === 'iw',
        required: false,
        ShowInSidebarNav: false,
      },
      li: {
        available: this.currentApp === 'li',
        required: false,
        ShowInSidebarNav: false,
      },
    };
    this.modStatusSvc.getApps(this.profile, this.noSaveProfile);
  }

  getQuestionnaire() {
    const existing = this.ss.get('noSave');
    this.setLoading(true);
    if (!this.unfFlowSvc.getSaving()) {
      if (this.noSaveProfile && this.currentApp !== 'summary' && existing) {
        if (existing.questionnaire) {
          const data = JSON.parse(
            JSON.stringify(this.ss.get('noSave').questionnaire)
          );
          this.profileData = data;
          this.setLoading(false);
        } else {
          this.rbs.getQuestions().subscribe(data => {
            this.unfFlowSvc.setStatusCheck();
            this.profileData = data.results.questionnaire;

            if (this.unfFlowSvc.copyCaseData()) {
              const copyParams = this.unfFlowSvc.copyCaseData();
              copyParams.destinationProfileId = this.profile;
              if (this.unfFlowSvc.copyCaseId()) {
                copyParams.sourceProfileId = this.unfFlowSvc.copyCaseId();
              }
              this.rbs.selectiveCopyProfile(copyParams).subscribe(resp => {
                if (resp.results.questionnaire) {
                  this.profileData = resp.results.questionnaire;
                  this.snacky.open(
                    `Case information was successfully imported. Please review each step to confirm and complete your recommendation.`,
                    'Close',
                    {
                      duration: 6000,
                    }
                  );
                }
                this.unfFlowSvc.copyCaseId.set(null);
                this.unfFlowSvc.copyCaseData.set(null);
                this.setLoading(false);
              });
            } else {
              this.setLoading(false);
            }
          });
        }
      } else {
        if (this.currentApp !== 'summary') {
          this.rbs
            .getQuestions(this.profile, this.currentApp)
            .subscribe(data => {
              this.profileData = data.results.questionnaire;
              if (this.currentStep === 0) {
                this.unfFlowSvc.setStatusCheck();
              }
              // TODO: Bandaid fix, need to find a real solution instead of settimeout
              setTimeout(() => {
                if (this.unfFlowSvc.copyCaseData()) {
                  const copyParams = this.unfFlowSvc.copyCaseData();
                  if (this.profile !== this.route.params?.['_value']?.id) {
                    copyParams.destinationProfileId =
                      this.route.params?.['_value']?.id;
                  } else {
                    copyParams.destinationProfileId = this.profile;
                  }
                  if (this.unfFlowSvc.copyCaseId()) {
                    copyParams.sourceProfileId = this.unfFlowSvc.copyCaseId();
                  }
                  this.rbs.selectiveCopyProfile(copyParams).subscribe(resp => {
                    if (resp.results.questionnaire) {
                      this.profileData = resp.results.questionnaire;
                      this.snacky.open(
                        `Case information was successfully imported. Please review each step to confirm and complete your recommendation.`,
                        'Close',
                        {
                          duration: 6000,
                        }
                      );
                    }
                    this.unfFlowSvc.copyCaseId.set(null);
                    this.unfFlowSvc.copyCaseData.set(null);
                    this.setLoading(false);
                  });
                } else {
                  this.setLoading(false);
                }
              }, 1000);

              this.navDisabled = false;
            });
        }
      }
    } else {
      setTimeout(() => {
        this.getQuestionnaire();
      }, 250);
    }
  }

  handleTabChange(ev) {
    const fromNav = ev['fromNav'] || false;
    const random = Math.floor(Math.random() * 10);
    const save = this.unfFlowSvc.getSaving();

    let nextTab;

    if (ev === 'next' && +this.currentStep + 1 <= this.steps.length) {
      nextTab = +this.currentStep + 1;
    } else if (ev === 'next' && +this.currentStep + 1 > this.steps.length) {
      nextTab = 'notQuestionnaire';
    }
    const guardParams = {
      currentApp: this.currentApp,
      currentStep: this.currentStep,
      requestedStep: nextTab,
      prodsSelectedPP: this.prodsSelectedPP,
      prodSelectedLW: this.prodSelectedLW,
      progSelectedIW: this.progSelectedIW,
      formValid: this.formValid,
      steps: this.steps,
    };
    let currentAppIdx = 0;
    if (
      this.isNaN(+ev) &&
      ev !== 'next' &&
      ev !== 'back' &&
      !Object.prototype.hasOwnProperty.call(ev, 'index')
    ) {
      if (
        this.unfFlowSvc.allowNavigation(
          true,
          fromNav,
          false,
          false,
          guardParams
        )
      ) {
        this.currentStep = ev;
        this.router.navigate([
          `/case/${this.currentApp}/${this.profile}/${this.currentStep}`,
        ]);
      }
      this.navDisabled = false;
    } else if (
      this.currentApp !== 'rb' &&
      this.isNaN(+this.currentStep) &&
      !this.isNaN(+ev.index)
    ) {
      this.setLoading(true);
      if (
        this.unfFlowSvc.allowNavigation(
          true,
          fromNav,
          false,
          false,
          guardParams
        )
      ) {
        this.getQuestionnaire();
        if (!this.isNaN(+this.currentStep)) {
          this.unfFlowSvc.setSaving(false);
        }
        this.currentStep = ev.index;
        this.router.navigate([
          `/case/${this.currentApp}/${this.profile}/${this.currentStep}`,
        ]);
      }
    } else if (ev === 'next') {
      const validationParam =
        this.steps.length === +this.currentStep + 1 ? 'all' : this.currentStep;

      if (!this.isNaN(+this.currentStep)) {
        this.unfFlowSvc.setTriggerValidate({ validate: validationParam });
      }

      if (this.isNaN(+this.currentStep)) {
        if (!save) {
          this.modStatusSvc.getNextApp(this.profile, this.currentApp);
        }

        if (
          this.unfFlowSvc.allowNavigation(
            true,
            fromNav,
            true,
            false,
            guardParams
          ) &&
          this.unfFlowSvc.getNoteValidity(this.currentApp)
        ) {
          // TODO
          // the following exception is to address the logic to NOT save on navigation to/from
          // non-numbered questionnaire pages. If we need this unconditionally in the future
          // for all pages, the save may block the app change logic.
          // A solution to this is to observe the save and trigger the change when the save completes.
          // I tried this and it caused trouble so the following is a least invasive QA bug fix.
          if (this.currentStep === 'investment-model') {
            this.unfFlowSvc.setTriggerSave({
              msg: 'unifiedTabSave-' + currentAppIdx,
              id: this.profile,
              appChange: false,
            });
          }

          currentAppIdx =
            this.currentApp === 'rb'
              ? -1
              : this.availableApps.indexOf(this.currentApp);
          const option = this.navOption();
          if (option && option !== 'appChange') {
            this.router.navigate([option]);
          }
          this.navDisabled = false;
        } else if (
          !this.unfFlowSvc.getNoteValidity(this.currentApp) &&
          !this.rights.includes('BridgeNotes') &&
          this.unfFlowSvc.allowNavigation(
            true,
            fromNav,
            true,
            false,
            guardParams
          )
        ) {
          currentAppIdx =
            this.currentApp === 'rb'
              ? -1
              : this.availableApps.indexOf(this.currentApp);
          const option = this.navOption();
          if (option && option !== 'appChange') {
            this.router.navigate([option]);
          }
          this.focusCatcher.nativeElement.focus();
          this.navDisabled = false;
        }
        this.navDisabled = false;
      } else if (
        this.currentApp === 'rb' &&
        this.steps.length === +this.currentStep + 1
      ) {
        if (
          this.unfFlowSvc.allowNavigation(
            true,
            fromNav,
            true,
            false,
            guardParams
          )
        ) {
          this.unfFlowSvc.setTriggerSave({
            msg: 'unifiedTabSave-' + currentAppIdx,
            id: this.profile,
            appChange: true,
          });
          this.focusCatcher.nativeElement.focus();
          this.navDisabled = false;
        } else {
          this.focusCatcher.nativeElement.focus();
          this.navDisabled = false;
        }
      } else if (
        this.currentApp !== 'rb' &&
        this.steps.length === +this.currentStep + 1
      ) {
        this.unfFlowSvc.setLoading(true);

        if (
          this.unfFlowSvc.allowNavigation(
            true,
            fromNav,
            true,
            false,
            guardParams
          )
        ) {
          this.ss.set('currentStep', 9999);
          const url = this.navOption();
          this.unfFlowSvc.setTriggerSave({
            msg: 'unifiedTabSave-' + random,
            id: this.profile,
            navOption: url,
          });
        } else {
          this.unfFlowSvc.setLoading(false);
          this.focusCatcher.nativeElement.focus();
          this.navDisabled = false;
        }
      } else {
        this.unfFlowSvc.setLoading(true);
        const existing = this.profile && this.profile.length > 0;
        const saveVal = existing
          ? `unifiedTabSave-${this.currentApp}-${this.currentStep}`
          : 'new-profile';
        this.unfFlowSvc.setTriggerSave({ msg: saveVal, id: this.profile });
        if (
          this.unfFlowSvc.allowNavigation(
            true,
            fromNav,
            true,
            false,
            guardParams
          ) &&
          +this.currentStep + 1 < this.steps.length
        ) {
          this.currentStep = +this.currentStep + 1;
          if (existing) {
            this.router.navigate([
              `/case/${this.currentApp}/${this.profile}/${this.currentStep}`,
            ]);
          }
          this.ss.set('currentStep', this.currentStep);
        }
        this.unfFlowSvc.setLoading(false);
      }
      this.focusCatcher.nativeElement.focus();
      this.navDisabled = false;
    } else if (ev === 'back') {
      if (
        this.currentStep !== 'validate' &&
        this.currentStep !== 'products' &&
        this.currentStep !== 'compare'
      ) {
        this.unfFlowSvc.setTriggerSave({
          msg: 'unifiedTabSave-' + this.currentStep,
          id: this.profile,
        });
      }

      if (this.currentApp === 'iw' && this.currentStep === 'validate') {
        this.unfFlowSvc.setNoteValidity({
          app: this.currentApp,
          valid: true,
        });
      }

      const timer =
        !this.isNaN(+this.profile) && this.profile.length > 7 ? 4000 : 0;

      this.location.back();
      this.focusCatcher.nativeElement.focus();

      this.triggerCheckGetQuestionnaire = true;
    } else if (fromNav && !this.isNaN(ev.index)) {
      this.unfFlowSvc.setTriggerSave({
        msg: 'unifiedTabSave-' + this.currentStep,
        id: this.profile,
      });
      this.currentStep = ev.index;
      this.router.navigate([
        `/case/${this.currentApp}/${this.profile}/${this.currentStep}`,
      ]);
      this.ss.set('currentStep', this.currentStep);
      this.focusCatcher.nativeElement.focus();
      this.navDisabled = false;
    } else {
      if (
        this.unfFlowSvc.allowNavigation(
          true,
          fromNav,
          false,
          false,
          guardParams
        )
      ) {
        this.unfFlowSvc.setTriggerSave({
          msg: 'unifiedTabSave-' + this.currentStep,
          id: this.profile,
        });
        this.currentStep = ev.index;
        this.router.navigate([
          `/case/${this.currentApp}/${this.profile}/${this.currentStep}`,
        ]);
        this.ss.set('currentStep', this.currentStep);
        this.navDisabled = false;
      }
      this.navDisabled = false;
      this.focusCatcher.nativeElement.focus();
    }
    this.navDisabled = false;
  }

  handleAppChange(ev?) {
    const fromNav = ev?.['fromNav'] || false;
    if (!this.unfFlowSvc.getSaving()) {
      let nextApp = ev?.app || null;
      if (!nextApp || nextApp === true) {
        this.modStatusSvc
          .getNextApp(this.profile, this.currentApp)
          .subscribe(newApp => {
            newApp =
              newApp.NextModule[
                `Module${this.currentApp.toUpperCase()}`
              ].toLowerCase();
            nextApp = newApp;

            this.handleAppNav(nextApp, fromNav);
          });
      } else {
        this.handleAppNav(nextApp, fromNav);
      }
      this.setModuleStatus();
    }
  }

  handleAppNav(nextApp, fromNav) {
    this.unfFlowSvc.setTriggerValidate({ validate: 'all' });

    const guardParams = {
      currentApp: this.currentApp,
      currentStep: this.currentStep,
      requestedApp: nextApp,
      prodsSelectedPP: this.prodsSelectedPP,
      prodSelectedLW: this.prodSelectedLW,
      progSelectedIW: this.progSelectedIW,
      formValid: this.formValid,
      steps: this.steps,
    };

    if (
      this.unfFlowSvc.allowNavigation(
        true,
        true,
        false,
        !this.formModified,
        guardParams
      ) &&
      this.formModified &&
      !this.isNaN(+this.currentStep)
    ) {
      let modifiedDialogRef = this.dialog.open(WarnDialogComponent, {
        panelClass: 'warn-dialog',
        data: {
          headline: 'Questionnaire Has Been Modified',
          content:
            'It appears you have updated data in the questionnaire. You will need to visit the results page before completing the case to ensure the case is updated. Would you like to visit there now?',
          confirm: 'Yes',
        },
      });
      modifiedDialogRef.afterClosed().subscribe(result => {
        if (result === 'continue') {
          this.frmSvc.formModified.set({
            modified: false,
            count: 0,
            values: {},
            app: this.currentApp,
          });
          if (this.currentApp === 'iw') {
            this.router.navigate([`case/iw/${this.profile}/validate`]);
          } else if (this.currentApp === 'li') {
            // LifeWizard_AssessmentType: 1 === select, 2 === validate
            if (
              this.formModel['LifeWizard_AssessmentType'] === '1' ||
              this.formModel['LifeWizard_AssessmentType'] === 1
            ) {
              this.router.navigate([`case/li/${this.profile}/products`]);
            } else if (
              this.formModel['LifeWizard_AssessmentType'] === '2' ||
              this.formModel['LifeWizard_AssessmentType'] === 2
            ) {
              this.router.navigate([`case/li/${this.profile}/validate`]);
            }
          } else {
            this.router.navigate([
              `/case/${this.currentApp}/${this.profile}/results`,
            ]);
          }
        }
        modifiedDialogRef = null;
      });
    } else if (
      this.unfFlowSvc.allowNavigation(true, true, false, true, guardParams) &&
      !this.formModified
    ) {
      if (!this.isNaN(+this.currentStep) && nextApp !== 'summary') {
        this.unfFlowSvc.setTriggerValidate({ validate: this.currentStep });
        if (!this.unfFlowSvc.getSaving()) {
          this.modStatusSvc.getApps(this.profile);
        }
      }

      const timer =
        (this.currentApp === 'rb' && fromNav && nextApp === 'pp') ||
        this.currentApp === 'iw'
          ? 1000
          : 500;

      const guardParams = {
        currentApp: this.currentApp,
        currentStep: this.currentStep,
        prodsSelectedPP: this.prodsSelectedPP,
        prodSelectedLW: this.prodSelectedLW,
        progSelectedIW: this.progSelectedIW,
        formValid: this.formValid,
        steps: this.steps,
      };

      this.unfFlowSvc.setNoteValidity({
        app: this.currentApp,
        valid: true,
      });
      this.steps = [];

      if (
        nextApp === 'summary' &&
        this.unfFlowSvc.allowNavigation(
          true,
          true,
          false,
          !fromNav,
          guardParams
        )
      ) {
        if (this.currentApp !== nextApp) {
          this.currentStep =
            nextApp === 'summary' || this.currentApp === 'summary'
              ? 'summary'
              : this.currentStep;
        }
        const nestedTimer =
          !this.isNaN(+this.profile) && this.profile.length > 7 ? 3000 : 0;

        this.router.navigate([`/case/summary/${this.profile}`]);
        this.ss.set('currentApp', this.currentApp);
        this.ss.set('currentStep', this.currentStep);
      } else if (nextApp !== 'summary' && nextApp !== 'cdrnotrequired') {
        if (
          (this.currentApp === 'rb' &&
            (this.unfFlowSvc.allowNavigation(
              true,
              true,
              false,
              true,
              guardParams
            ) ||
              this.modStatusSvc.clientInfoNotRequired())) ||
          this.currentApp !== 'rb'
        ) {
          if (this.currentApp !== nextApp && nextApp) {
            this.currentApp = nextApp;
            this.currentStep = 0;
          }
          this.getQuestionnaire();
          this.router.navigate([
            `/case/${this.currentApp}/${this.profile}/${this.currentStep}`,
          ]);
          this.ss.set('currentApp', this.currentApp);
          this.ss.set('currentStep', this.currentStep);
          this.rbs.setApp(this.currentApp);
        }
      } else if (nextApp === 'cdrnotrequired') {
        this.router.navigate([`/cdrnotrequired`]);
      }
    }
  }

  handleAppPage(ev, noSave = false) {
    this.unfFlowSvc.setLoading(true);
    this.unfFlowSvc.setTriggerValidate({ validate: 'all' });
    const save = this.unfFlowSvc.getSaving();

    if (save) {
      setTimeout(() => {
        this.handleAppPage(ev, true);
      }, 250);
    } else {
      const guardParams = {
        currentApp: this.currentApp,
        currentStep: this.currentStep,
        prodsSelectedPP: this.prodsSelectedPP,
        prodSelectedLW: this.prodSelectedLW,
        progSelectedIW: this.progSelectedIW,
        iwValidateTrack: this.iwValidate,
        formValid: this.formValid,
        steps: this.steps,
        requestedStep: ev.tab,
      };

      if (
        this.unfFlowSvc.allowNavigation(false, true, false, false, guardParams)
      ) {
        if (!noSave && !this.isNaN(+this.currentStep)) {
          const random = Math.floor(Math.random() * 10);
          this.unfFlowSvc.setTriggerSave({
            msg: 'appPageSave-' + random,
            id: this.profile,
          });
        }
        this.frmSvc.formModified.set({
          modified: false,
          count: 0,
          values: {},
          app: this.currentApp,
        });
        this.currentStep = ev.tab;
        this.router.navigate([
          `/case/${this.currentApp}/${this.profile}/${this.currentStep}`,
        ]);
      }
    }
  }

  handleNewProfile(ev) {
    this.profile = ev;
    let app = this.currentApp;
    let step = 0;

    if (this.currentApp === 'rb') {
      const currentAppIdx =
        this.currentApp === 'rb'
          ? -1
          : this.availableApps.indexOf(this.currentApp);
      app = this.availableApps[+currentAppIdx + 1];
    } else {
      step++;
    }

    this.router.navigate([`/case/${app}/${this.profile}/${step}`]);
  }

  handleModelChange(ev) {
    this.formModel = ev.model;
    if (
      ev.model['LifeWizard_AssessmentType'] &&
      (ev.model['LifeWizard_AssessmentType'] === 2 ||
        ev.model['LifeWizard_AssessmentType'] === '2')
    ) {
      this.liValidate = true;
    } else if (
      ev.model['LifeWizard_AssessmentType'] &&
      ev.model['LifeWizard_AssessmentType'] !== 2 &&
      ev.model['LifeWizard_AssessmentType'] !== '2'
    ) {
      this.liValidate = false;
    }

    if (
      ev.model.ValidateProduct &&
      ev.model.ValidateProduct['InvestmentWizard_AssessmentType'] &&
      (ev.model.ValidateProduct['InvestmentWizard_AssessmentType'] === 2 ||
        ev.model.ValidateProduct['InvestmentWizard_AssessmentType'] === '2')
    ) {
      this.iwValidate = true;
    } else if (
      ev.model.ValidateProduct &&
      ev.model.ValidateProduct['InvestmentWizard_AssessmentType'] &&
      ev.model.ValidateProduct['InvestmentWizard_AssessmentType'] !== 2 &&
      ev.model.ValidateProduct['InvestmentWizard_AssessmentType'] !== '2'
    ) {
      this.iwValidate = false;
    }
    if (this.formModel['InvestmentWizard_SelectedProgram'])
      this.handleIWProg({
        program: this.formModel['InvestmentWizard_SelectedProgram'],
        selectionType: this.formModel['SelectedProgramData_FundSelectionType'],
      });
  }

  currentStepDisplay() {
    if (this.currentApp === 'summary') {
      return this.summaryClient;
    }
    if (!this.isNaN(+this.currentStep)) {
      return this.steps[this.currentStep]
        ? this.steps[this.currentStep].label
        : null;
    } else {
      let title;
      switch (this.currentStep) {
        case 'investment-model':
          title = 'Investment Model';
          break;
        case 'program-selection':
          title = 'Program Selection';
          break;
        case 'fund-allocations':
          title = 'Fund Allocations';
          break;
        case 'validate':
          if (this.currentApp === 'iw') {
            title = 'Results';
          } else {
            title = 'Validate Products';
          }
          break;
        case 'advisory':
          title = 'Advisory';
          break;
        case 'compare-results':
          title = 'Income Comparison';
          break;
        case 'results':
          if (this.currentApp === 'li') {
            title = 'Calculated Needs Results';
          } else {
            title = 'Results';
          }
          break;
        case 'needs':
          title = 'Calculated Needs Results';
          break;
        case 'compare':
          title = 'Compare Scenarios';
          break;
        case 'products':
          title = 'Product Considerations';
          break;
      }
      return title;
    }
  }

  currentAppDisplay() {
    switch (this.currentApp) {
      case 'pp':
        return 'Product Profiler';
      case 'aw':
        return 'Annuity Wizard';
      case 'iw':
        return 'Investment Wizard';
      case 'li':
        return 'Life Insurance Wizard';
      case 'rb':
        return 'Client Information';
      case 'summary':
        return 'Case Summary';
    }
  }

  navOption(returnStepName = false) {
    this.modStatusSvc.getNextApp(this.profile, this.currentApp);

    switch (this.currentApp) {
      case 'pp':
        if (this.currentStep === 'results') {
          this.handleAppChange();
          return 'appChange';
        } else {
          this.setLoading(true);
          this.currentStep = 'results';
          return returnStepName ? 'results' : `case/pp/${this.profile}/results`;
        }
      case 'aw':
        if (this.currentStep === 'results') {
          this.handleAppChange();
          return 'appChange';
        } else if (
          this.currentStep * 1 === this.steps.length - 1 &&
          this.modStatusSvc.hasAwComparisonPage()
        ) {
          this.currentStep = 'compare-results';
          return returnStepName
            ? 'compare-results'
            : `case/aw/${this.profile}/compare-results`;
        } else {
          if (this.noSaveProfile) {
            this.currentStep = 'results';
            return returnStepName
              ? 'results'
              : `case/aw/${this.profile}/results`;
          } else {
            this.currentStep = 'results';
            return returnStepName
              ? 'results'
              : `case/aw/${this.profile}/results`;
          }
        }
      case 'iw':
        if (this.currentStep === 'program-selection') {
          if (this.progSelectedIW.selectionType.toLowerCase() === 'advisory') {
            this.currentStep = 'validate';
            return returnStepName
              ? 'validate'
              : `case/iw/${this.profile}/validate`;
          } else {
            this.currentStep = 'investment-model';
            return returnStepName
              ? 'investment-model'
              : `case/iw/${this.profile}/investment-model`;
          }
        } else if (this.currentStep === 'investment-model') {
          this.currentStep = 'fund-allocations';
          return returnStepName
            ? 'fund-allocations'
            : `case/iw/${this.profile}/fund-allocations`;
        } else if (this.currentStep === 'fund-allocations') {
          this.currentStep = 'validate';
          return returnStepName
            ? 'validate'
            : `case/iw/${this.profile}/validate`;
        } else if (
          this.currentStep === 'advisory' ||
          this.currentStep === 'validate'
        ) {
          this.handleAppChange();
          return 'appChange';
        } else if (
          this.formModel['ValidateProduct'][
            'InvestmentWizard_AssessmentType'
          ] === 2 ||
          this.formModel['ValidateProduct'][
            'InvestmentWizard_AssessmentType'
          ] === '2'
        ) {
          this.currentStep = 'validate';
          return returnStepName
            ? 'validate'
            : `case/iw/${this.profile}/validate`;
        } else {
          this.currentStep = 'program-selection';
          return returnStepName
            ? 'program-selection'
            : `case/iw/${this.profile}/program-selection`;
        }
      case 'li': {
        const gotoAnalysis = this.formModel[
          'UnitNeeds_PurposesUsingCalc'
        ]?.includes(this.formModel['LifeWizard_InsurancePurpose']);
        const gotoStrategies = !this.formModel[
          'UnitNeeds_PurposesUsingCalc'
        ]?.includes(this.formModel['LifeWizard_InsurancePurpose']);

        if (
          this.currentStep === 'products' ||
          this.currentStep === 'validate'
        ) {
          this.handleAppChange();
          return 'appChange';
        } else if (
          ((this.formModel['LifeWizard_AssessmentType'] === 2 ||
            this.formModel['LifeWizard_AssessmentType'] === '2') &&
            this.formModel['UnitRegulationState_States'].includes(
              this.formModel['LifeWizard_StateOfIssue']
            )) ||
          this.formModel['LifeWizard_PurchaseType'] === 2
        ) {
          this.currentStep = 'validate';
          return returnStepName
            ? 'validate'
            : `case/li/${this.profile}/validate`;
        } else if (this.currentStep === 'compare') {
          this.currentStep = 'products';
          return returnStepName
            ? 'products'
            : `case/li/${this.profile}/products`;
        } else if (this.currentStep === 'results') {
          this.currentStep = 'compare';
          return returnStepName ? 'compare' : `case/li/${this.profile}/compare`;
        } else if (gotoStrategies) {
          this.currentStep = 'compare';
          return returnStepName ? 'compare' : `case/li/${this.profile}/compare`;
        } else if (gotoAnalysis) {
          this.currentStep = 'results';
          return returnStepName ? 'results' : `case/li/${this.profile}/results`;
        } else {
          this.currentStep = 'results';
          return returnStepName ? 'results' : `case/li/${this.profile}/results`;
        }
      }
    }
  }

  hideForm() {
    if (
      this.unfFlowSvc.getloading() ||
      this.isNaN(+this.currentStep) ||
      this.currentApp === 'summary'
    ) {
      return true;
    }
  }

  checkStatus() {
    return (
      (this.currentApp !== 'summary' && !this.isNaN(+this.currentStep)) ||
      this.currentApp !== 'compare-results'
    );
  }

  handlePPProds(ev) {
    this.prodsSelectedPP = ev;
  }

  handleIWProg(ev) {
    this.progSelectedIW = ev;
  }

  handleLWProd(ev) {
    this.prodSelectedLW = ev;
  }

  handleSummaryNavigate(ev) {
    if (ev.app === 'back') {
      const timer =
        !this.isNaN(+this.profile) && this.profile.length > 7 ? 3000 : 0;

      this.location.back();
    } else {
      this.currentApp = ev.app;
      this.currentStep = ev.step;

      this.router.navigate([
        `/case/${this.currentApp}/${this.profile}/${this.currentStep}`,
      ]);
      this.getQuestionnaire();
    }
  }

  setSummaryClient(e) {
    if (e) {
      const clientName =
        e.Client.Client.FinalName ||
        e.Client.ClientPerson.FirstName + ' ' + e.Client.ClientPerson.LastName;
      this.summaryClient = clientName.replace('undefined', '');
      this.summaryCaseNumber = e.Client.SummaryPage.CaseNumber;
    }
  }

  setLoading(state) {
    this.unfFlowSvc.setLoading(state);
  }

  downloadFactsheet(e) {
    this.downloadingFactsheet = e;
  }

  saveInProgress() {
    const random = Math.floor(Math.random() * 10);
    this.unfFlowSvc.setTriggerSave({
      msg: 'inProgressSave-' + random,
      id: this.profile,
    });
  }

  showImportCaseButton() {
    const globals = this.ss.get('globals');

    if (
      this.currentApp !== 'summary' &&
      !this.isNaN(+this.currentStep) &&
      this.rights.includes('SelectiveCopyCase') &&
      !this.noSaveProfile &&
      !this.rights.includes('ReadOnlyAccess') &&
      globals.GlobalsGroup?.UnitCopySettings?.CopyOnQuestionnaireOption
    ) {
      return true;
    }
    return false;
  }

  copyCase() {
    const copyCaseDialogRef = this.dialog.open(CopyCaseModalComponent, {
      width: '98vw',
      autoFocus: false,
      data: { profile: this.profile, importClick: true },
    });

    copyCaseDialogRef.afterClosed().subscribe(resp => {
      if (resp.data && resp.data !== 'cancel') {
        this.profileData = resp.data;
        this.router.navigate([`/case/rb/${this.profile}/0`]);
      }
      this.unfFlowSvc.setLoading(false);
    });
  }

  aiSummaryChecked(ev) {
    let triggerSave = false;
    if (
      Object.prototype.hasOwnProperty.call(
        this.formModel['model'],
        'AICaseSummary_SummaryValidated'
      ) &&
      this.formModel['model']['AICaseSummary_SummaryValidated'] !== ev
    ) {
      triggerSave = true;
      this.formModel['model']['AICaseSummary_SummaryValidated'] = ev;
    } else {
      triggerSave = true;
      Object.assign(this.formModel['model'], {
        AICaseSummary_SummaryValidated: ev,
      });
    }
    if (triggerSave) {
      const random = Math.floor(Math.random() * 10);
      this.unfFlowSvc.setTriggerSave({
        msg: 'appPageSave-' + random,
        id: this.profile,
      });
    }
  }

  updateModel({ field, value }) {
    this.formModel[field] = value;
  }
}
